import * as XLSX from 'xlsx';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let promptFn = null;
let requesterId = () => '';
export const registerExcelPasswordPrompt = (fn, getRequesterId) => {
  promptFn = fn; requesterId = getRequesterId || requesterId;
  return () => { if (promptFn === fn) promptFn = null; };
};

export const isPasswordProtectedError = (e) => /password/i.test(String(e?.message || e || ''));
export class ExcelCancelledError extends Error { constructor() { super('Password entry cancelled'); this.cancelled = true; } }

async function decryptViaServer(file) {
  let error = '';
  for (;;) {
    if (!promptFn) throw new Error('This file is password-protected. Please remove the password and try again.');
    const password = await promptFn({ fileName: file.name, error });
    if (password == null) throw new ExcelCancelledError();
    const fd = new FormData();
    fd.append('requester_id', requesterId());
    fd.append('password', password);
    fd.append('file', file);
    try {
      const r = await axios.post(`${API}/excel/decrypt`, fd, { responseType: 'arraybuffer' });
      return new File([r.data], file.name, { type: file.type });
    } catch (e) {
      if (e.response?.status === 400) { error = 'Incorrect password — try again'; continue; }
      let detail = 'Could not decrypt file';
      try { detail = JSON.parse(new TextDecoder().decode(e.response?.data))?.detail || detail; } catch { /* ignore */ }
      throw new Error(detail);
    }
  }
}

/** Reads a workbook; if the file is password-protected, prompts for the password and decrypts it server-side.
 *  Returns { wb, file } where `file` is the readable (decrypted) File to forward to any backend upload. */
export async function readWorkbook(file, opts = {}) {
  const buf = await file.arrayBuffer();
  try {
    return { wb: XLSX.read(buf, { type: 'array', ...opts }), file };
  } catch (e) {
    if (!isPasswordProtectedError(e)) throw e;
  }
  const plain = await decryptViaServer(file);
  return { wb: XLSX.read(await plain.arrayBuffer(), { type: 'array', ...opts }), file: plain };
}
